/*
 * MixPanel
 * Trigger events to MixPanel Apis
 *
 * @author: Elton Jain
 */
/*global mixpanel, define*/

define('Mixpanel',[], function() {
    'use strict';

    var ApiList = {},
        MixPanel = {},
        is_initialized = false; // Mixpanel global object ref

    ApiList = {
        // template: {
        //     name: 'data point name',
        //     callback: function (data) {

        //     }
        // },
        // Click
        click: {
            name: 'PT Click',
            callback: function(data, callback) {
                // @input: target, position
                if(!data.target) {
                    console.log('mx click: data target required');
                }
                mixpanel.track(
                    this.name, data
                );
                if(callback) {
                    callback();
                }
            }
        },
        // Open
        open: {
            name: 'PT Open',
            callback: function(data, callback) {
                // @input: target, position
                if(!data.target) {
                    console.log('mx open: data target required');
                }
                mixpanel.track(
                    this.name, data
                );
                if(callback) {
                    callback();
                }
            }
        },
        // Share tracking
        share_social: {
            name: 'PT Share',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        type: data.type,
                        url: (data.url) ? data.url : null,
                        content: data.content
                    }
                );
            }
        },

        // Invite tracking
        invite_social: {
            name: 'PT User Invite Sent',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        type: data.type,
                        url: data.url
                    }
                );
            }
        },

        // Generic user event
        user_event: {
            callback: function(data, callback) {

                if(!data.event) {
                    return;
                } else {
                    var event_name = data.event;
                }

                delete(data.event);

                mixpanel.track(
                    event_name,data
                );

                if(callback) {
                    callback();
                }
            }
        },
        // Post a question
        question_create: {
            name: 'PT Post Question',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        'question_id': data.question_id,
                        'question_text': data.question_text,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
                // Update count
                mixpanel.people.increment('questions_asked', 1);
            }
        },
        // Post an answer
        answer_create: {
            name: 'PT Post Reply',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        'question_id': data.question_id,
                        'reply_id': data.reply_id,
                        'reply_text': data.reply_text,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
                // Update count
                mixpanel.people.increment('answers_posted', 1);
            }
        },
        // Post a comment
        comment_create: {
            name: 'PT Post Comment',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        'reply_id': data.reply_id,
                        'comment_id': data.comment_id,
                        'user': data.user,
                        'user_id': data.user_id,
                        'comment_text': data.comment_text
                    }
                );
            }
        },
        // Like a question
        question_like: {
            name: 'PT Like Question',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        'question_id': data.question_id,
                        'question_text': data.question_text,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
            }
        },
        // Like an answer
        answer_like: {
            name: 'PT Like Reply',
            callback: function(data) {
                mixpanel.track(
                    this.name, {
                        'question_id': data.question_id,
                        'reply_id': data.reply_id,
                        'reply_text': data.reply_text,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
            }
        },
        // Follow topic
        follow_topic: {
            name: 'PT Follow Topic',
            callback: function(data, callback) {

                mixpanel.track(
                    this.name, {
                        'topic_name': data.topic_name,
                        'topic_id': data.topic_id,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
                // Total user topic count
                mixpanel.people.increment('topics_followed', 1);

                if(callback) {
                    callback();
                }
            }
        },
        // Unfollow topic
        unfollow_topic: {
            name: 'PT Unfollow Topic',
            callback: function(data, callback) {
                mixpanel.track(
                    this.name, {
                        'topic_name': data.topic_name,
                        'topic_id': data.topic_id,
                        'user': data.user,
                        'user_id': data.user_id
                    }
                );
                // Total user topic count
                mixpanel.people.increment('topics_followed', -1);

                if(callback) {
                    callback();
                }
            }
        },
        // Follow Question
        question_follow: {
            name: 'PT Follow Question',
            callback: function(data, callback) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Unfollow Question
        question_unfollow: {
            name: 'PT Unfollow Question',
            callback: function(data, callback) {
                mixpanel.track(
                    this.name, data
                );
            }
        },

        // Create Group (Public, Private)
        group_create: {
            name: 'PT Create Public Group',
            callback: function(data, callback) {
                var api = 'PT Join Public Group';

                if (data.is_private === true) {
                    api = 'PT Create Private Group';
                }
                mixpanel.track(
                    api, {
                        'group_name': data.group_name,
                        'group_id': data.group_id,
                        'user': data.user,
                        'user_id': data.user_id
                    },
                    callback
                );
            }
        },
        // Edit User Profile
        edit_profile: {
            name: 'PT Edit Profile',
            callback: function(data) {
                mixpanel.track(
                    this.name,
                    data
                );
            }
        },
        // Update Profile Photo
        update_profile_photo: {
            name: 'PT Update Profile Photo',
            callback: function(data) {
                mixpanel.track(
                    this.name,
                    data
                );
            }
        },
        // Set Default Site
        set_site: {
            name: 'TAP Site',
            callback: function(data) {
                var mxData = {};
                mxData[this.name] = 'ParentTown';

                require(['Config'], function (Config) {
                    mxData['TAP Site Stage'] = Config.get('env');

                    if(window._gtap.settings.device === 'mobile') {
                        mxData['$device'] = 'mobile';    
                    } else {
                        mxData['$device'] = 'desktop';    
                    }

                    mxData['Page'] = Config.get('page.route')
                    mixpanel.register(mxData);
                });
            }
        },
        // Sign up / Register
        signup: {
            name: 'PT Sign Up',
            callback: function(data, callback) {
                var flag_alldone = 0;

                if(window._invited_email_) {
                    //mixpanel.identify(window._invited_email_);
                    // (new, existing)
                    mixpanel.alias(data.email, window._invited_email_);
                } else {
                    mixpanel.alias(data.email);
                }
                mixpanel.people.set({
                    '$first_name': data.firstname,
                    '$last_name': data.lastname,
                    '$created': data.created_at,
                    '$email': data.email,
                    'gender': data.gender,
                    'timezone': data.timezone,
                    'birthday': data.birthday,
                    'parenttown_id': data.user_id,
                    'topics_followed': 0
                },
                function () {
                   if(++flag_alldone === 2) {
                        callback();
                   }
                });
                mixpanel.track(
                    this.name, {
                        login_type: data.login_type,
                        trigger_source: data.trigger_source
                    },
                    function () {
                       if(++flag_alldone === 2) {
                        callback();
                       }
                    }
                );
            }
        },
        // Login
        login: {
            name: 'PT Login',
            callback: function(data, callback) {
                mixpanel.identify(data.email);
                var flag_alldone = 0;

                mixpanel.people.set({
                    '$first_name': data.firstname,
                    '$last_name': data.lastname,
                    '$created': data.created_at,
                    '$email': data.email,
                    'gender': data.gender,
                    'timezone': data.timezone,
                    'birthday': data.birthday,
                    'parenttown_id': data.user_id,
                    'questions_asked': data.questions_asked,
                    'answers_posted': data.answers_posted
                },
                function () {
                   if(++flag_alldone === 2) {
                        callback();
                   }
                });

                mixpanel.track(
                    this.name, {
                        login_type: data.login_type,
                        trigger_source: data.trigger_source
                    },
                    function () {
                       if(++flag_alldone === 2) {
                            callback();
                       }
                    }
                );
            }
        },
        // Login Button Clicked
        // Can be signups, Just tracking click rates to compare success rates
        login_click: {
            name: 'PT Login Clicked',
            callback: function(data, callback) {
                mixpanel.track(
                    this.name, {
                        login_type: data.login_type,
                        trigger_source: data.trigger_source
                    },
                    callback
                );
            }
        },
        // Visit Home page
        visit_page: {
            name: 'PT Page Visit',
            callback: function(data, callback) {
                var mxData = {
                    page: data.page
                };

                if(data.title) {
                    mxData.page_title = data.title;
                }
                if(data.content_id) {
                    mxData.content_id = data.content_id
                }
                if(data.type) {
                    mxData.type = data.type;
                }

                mixpanel.track(
                    this.name, mxData
                );
            }
        },
        // Seen onboarding
        visit_prelogin: {
            name: 'PT Visit Prelogin',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Visits notification page
        visit_notification:{
            name: 'PT Visit Notification',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Visit My Profile
        visit_my_profile:{
            name: 'PT Visit My Profile',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Visits search page
        visit_search_page: {
            name: 'PT Visit Search Page',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        visit_find_groups: {
            name: 'PT Visit Find Groups',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        login_popup: {
            name: 'PT Login Popup',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        login_banner: {
            name: 'PT Login From Banner Clicked',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Swiping onboarding carousel
        swipe_prelogin: {
            name: 'PT Swipe Prelogin',
            callback: function(data) {
                // Will be Slide number
                mixpanel.track(
                    this.name, data
                   );
            }
        },
        // User onboarding steps
        user_onboard_steps: {
            name: 'PT Onboard Step',
            callback: function (data, callback) {
                /**
                 * @input: step number, step name, step action
                 * @input: step data - data.data = {num_boys: value, weeks_pregnant: value}
                 */
                
                var mxData = {};
                if(data.step) {mxData.step = data.step;}
                if(data.step_name) {mxData.step_name = data.step_name;}
                if(data.step_action) {mxData.step_action = data.step_action;}
                mixpanel.identify(data.email);

                // Hit track for step and step action
                // Add step data to People data
                mixpanel.track('PT Onboard Step', mxData);
                mixpanel.people.set(data.data);
                
                if(callback) {
                    callback();
                }
            }
        },
        // Click on invite link
        invite_link_click: {
            name: 'PT Invite Email Clicked',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            } 
        },

        // Onboarding step: are you pregant
        /*user_pregnant: {
            name: 'PT Is Pregnant',
            callback: function(data) {
                mixpanel.identify(data.email);

                mixpanel.people.set({
                    'is_pregnant': data.is_pregnant
                });
            }
        },
        // Onboarding step: congratulations
        weeks_pregnant: {
            name: 'PT Number of Weeks',
            callback: function(data) {
                mixpanel.identify(data.email);

                mixpanel.people.set({
                    'weeks_pregnant': data.weeks_pregnant,
                });
            }
        },
        // Onboarding step: are you trying to conceive
        trying_to_conceive: {
            name: 'PT Trying to Conceive',
            callback: function(data) {
                mixpanel.identify(data.email);

                mixpanel.people.set({
                    'trying_to_conceive': data.trying_to_conceive,
                });
            }
        },
        // Onboarding step: number of children
        num_children: {
            name: 'PT Number of Children',
            callback: function(data) {
                mixpanel.identify(data.email);

                mixpanel.people.set({
                    'num_boys': data.num_boys,
                    'num_girls': data.num_girls
                });
            }
        },*/
        // Login swipes
        carousel_swipe: {
            name: 'PT Carousel',
            callback: function(data) {
                // Will be Slide number
                data.event = 'swipe';
                data.trigger_source = 'carousel';
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Carousel Indicator Click
        carousel_indicator_click: {
            name: 'PT Carousel',
            callback: function(data) {
                // Will be Slide number
                data.event = 'click indicator';
                data.trigger_source = 'indicator';
                mixpanel.track(
                    this.name, data
                );
            }
        },
        // Carousel Close button
        carousel_close: {
            name: 'PT Carousel',
            callback: function(data) {
                // Will be Slide number
                data.event = 'close';
                data.trigger_source = 'close button';
                mixpanel.track(
                    this.name, data
                );
            }
        },
        onboarding_complete: {
            name: 'PT Onboarding Complete',
            callback: function(data) {
                // Will be Slide number
                mixpanel.track(
                    this.name, data
                );
                mixpanel.people.set({
                    'register_step': 0,
                });
            }
        },
        count_load_more: {
            name: 'PT Count Load More Clicks',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        menu_open: {
            name: 'PT Menu Open',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        },
        follow_profile: {
            name: 'PT Follow Profile',
            callback: function(data) {
                mixpanel.track(
                    this.name, data
                );
            }
        }

    };


    MixPanel = {
        loadSDK: function() {
            (function(f, b) {
                if (!b.__SV) {
                    var a, e, i, g;
                    window.mixpanel = b;
                    b._i = [];
                    b.init = function(a, e, d) {
                        function f(b, h) {
                            var a = h.split('.');
                            2 == a.length && (b = b[a[0]], h = a[1]);
                            b[h] = function() {
                                b.push([h].concat(Array.prototype.slice.call(arguments, 0)))
                            }
                        }
                        var c = b;
                        'undefined' !== typeof d ? c = b[d] = [] : d = 'mixpanel';
                        c.people = c.people || [];
                        c.toString = function(b) {
                            var a = 'mixpanel';
                            'mixpanel' !== d && (a += '.' + d);
                            b || (a += ' (stub)');
                            return a
                        };
                        c.people.toString = function() {
                            return c.toString(1) + '.people (stub)'
                        };
                        i = 'disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(' ');
                        for (g = 0; g < i.length; g++) f(c, i[g]);
                        b._i.push([a, e, d])
                    };
                    b.__SV = 1.2;
                    a = f.createElement('script');
                    a.type = 'text/javascript';
                    a.async = !0;
                    a.src = 'undefined' !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
                    e = f.getElementsByTagName('script')[0];
                    e.parentNode.insertBefore(a, e)
                }
            })(document, window.mixpanel || []);
        },

        init: function() {
            // Initialize Mixpanel
            this.loadSDK();
            if (mixpanel) {
                mixpanel.init('54605a9dc588acdc8e56b6d035b59538');
                is_initialized = true;
            } else {
                console.log('mixpanel not loaded.');
            }
        },
        identify: function(email) {
            if (!is_initialized) {
                base.init();
            }
            mixpanel.identify(email);
        },
        // Hit the API
        hit: function(event, data, callback) {
            var base = this,
                mx_events = ['PT Photo Like','PT Photo Comment', 'PT TV Play','PT Feed User Invite'];
            if (!is_initialized) {
                base.init();
            }

            // If calling via user_event
            if(data && data.event) {
                if(mx_events.indexOf(data.event) == -1) {
                    return;
                }
            }

            // Parse Event detail from Api List and make an ajax call
            if (ApiList[event]) {
                ApiList[event].callback(data, callback);
            } else {
                console.log('event not found');
            }


        }
    };


    return MixPanel;
});
